import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

const formatParams = (params) => {
  // 过滤空值
  Object.keys(params).map(key => {
    if (params[key] === '') {
      delete params[key]
    }
  })

  return params
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.params) {
      config.params = formatParams(config.params)
    }

    if (config.data) {
      config.data = formatParams(config.data)
    }

    if (!config.headers['authorization'] && getToken()) {
      config.headers.authorization = `Bearer ${getToken()}`
    }

    // do something before request is sent
    config.withCredentials = true
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.params = {
        ...config.params,
        token: getToken()
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log('response',response);
    if (
      res.code !== 0 // code 不是0 则是错误
      && 
      !response.config.url.includes('middle-ground/general-api')  // 中台接口中转直接返回
    ) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      if (res.code === 2) { }

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.code === 422) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    console.log(error.response)
    if (error.response) {
      Message({
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      })

      return false
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
